import { useState } from 'react';

import { useMutation } from '@apollo/client';

import createCorrectAnswersByIdMap from '~/components/QuestionQuiz/createCorrectAnswersByIdMap';
import { useTenantContext } from '~/context/TenantProvider';
import { useUserInfoContext } from '~/context/UserInfoProvider';
import { CHECK_N_RECORD_VIDEO_QUESTION_ANSWERS } from '~/graphql/pathways';
import { QUESTION_TYPES } from '~/pages/const';
import { Mutation, MutationCheck_N_Record_Video_Question_AnswersArgs } from '~/types';

const useCheckQuizAnswers = ({
  questionId,
  type,
  selectedAnswersIds,
  videoId,
  onSuccess,
  duration,
}) => {
  const { userInfo } = useUserInfoContext();
  const { tenant } = useTenantContext();
  const [isCorrectByIdMap, setIsCorrectByIdMap] = useState({});
  const [submittedQuestionsIds, setSubmittedQuestionsIds] = useState<string[]>([]);

  const [submitQuizAnswers] = useMutation<
    Pick<Mutation, 'check_n_record_video_question_answers'>,
    MutationCheck_N_Record_Video_Question_AnswersArgs
  >(CHECK_N_RECORD_VIDEO_QUESTION_ANSWERS);

  const checkQuizAnswers = (questions) => {
    submitQuizAnswers({
      variables: {
        input: {
          tenant_id: Number(tenant?.id),
          questions: questions,
          user_id: Number(userInfo?.id),
          time_passing: duration,
          video_id: Number(videoId),
        },
      },
      onCompleted: ({ check_n_record_video_question_answers }) => {
        const question = check_n_record_video_question_answers?.passed_questions_answers?.find(
          (a) => a?.question?.id === questionId,
        );

        setSubmittedQuestionsIds(questionId);

        const updatedAnswers = question?.correct_answers;
        const isCorrectByIdMap = createCorrectAnswersByIdMap(questionId, type, updatedAnswers);
        setIsCorrectByIdMap(isCorrectByIdMap);

        const correctIds = Object.keys(isCorrectByIdMap);
        let isEveryCorrectSelected = correctIds.every((id) => selectedAnswersIds.includes(id));

        if (type === QUESTION_TYPES.ordered) {
          isEveryCorrectSelected = !!question?.correct;
        }

        if (isEveryCorrectSelected) {
          onSuccess();
        }
      },
    });
  };

  return { checkQuizAnswers, isCorrectByIdMap, submittedQuestionsIds };
};

export default useCheckQuizAnswers;
